import { Component, OnInit } from '@angular/core';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import { HelpdeskService } from 'src/app/services/delavci/helpdesk.service';
@Component({
  selector: 'app-dokumenti-dialog',
  templateUrl: './dokumenti-dialog.component.html',
  styleUrls: ['./dokumenti-dialog.component.css']
})
export class DokumentiDialogComponent implements OnInit {

  constructor(private helpdeskService: HelpdeskService) { }

  ngOnInit() {
  }

  delete() {

  }
}
